import utils from "@/utilities/Utils";

export class SearchParameters {
    pageNumber: number = 1;
    id: string = utils.emptyGuidValue;
    numericID: number = 0;
    searchText: string = "";
    showHidden: boolean = false;
}